import { Button } from "../../components/Button";
import { useCopyToClipboard } from "../../hooks";
import { Clipboard, ClipboardCheck, Download01, } from "../../icons/v2-stroke";
import { cn } from "../../lib/utils";
import { cva } from "class-variance-authority";
import React, { useCallback } from "react";
const contentTypeExtensions = {
    "application/json": ".json",
    "text/csv": ".csv",
};
const wrapperVariants = cva("s-group s-relative s-w-full s-max-w-full s-min-w-0 !s-overflow-visible", {
    variants: {
        buttonDisplay: {
            inside: "s-mt-0",
            outside: "s-mt-11",
        },
    },
    defaultVariants: {
        buttonDisplay: "outside",
    },
});
const actionsVariants = cva("s-absolute s-right-2 s-flex s-items-center s-gap-1 s-py-2", {
    variants: {
        buttonDisplay: {
            inside: "",
            outside: "s-bottom-0 s-h-11",
        },
        displayActions: {
            hover: "s-opacity-0 s-transition-opacity s-duration-200 group-hover:s-opacity-100",
            always: "",
        },
    },
    defaultVariants: {
        buttonDisplay: "outside",
        displayActions: "always",
    },
});
export function ContentBlockWrapper({ children, className, innerClassName, content, actions, displayActions = "always", getContentToDownload, buttonDisplay = "outside", }) {
    const [isCopied, copyToClipboard] = useCopyToClipboard();
    const handleCopyToClipboard = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!content) {
            return;
        }
        const rawContent = typeof content === "string" ? { "text/plain": content } : content;
        // Replace invisible non-breaking spaces with regular spaces.
        if (rawContent["text/plain"]) {
            rawContent["text/plain"] = rawContent["text/plain"]
                .replaceAll("\xa0", " ")
                .trim();
        }
        const data = new ClipboardItem(Object.entries(rawContent).reduce((acc, [type, data]) => {
            acc[type] = new Blob([data], { type });
            return acc;
        }, {}));
        void copyToClipboard(data);
    }, [content, copyToClipboard]);
    const handleDownload = useCallback(async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!getContentToDownload) {
            return;
        }
        const { content, filename, type } = await getContentToDownload();
        const blob = new Blob([content], { type });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.${contentTypeExtensions[type]}`;
        a.click();
    }, [getContentToDownload]);
    return (React.createElement("div", { className: cn(wrapperVariants({ buttonDisplay }), className) },
        buttonDisplay !== null && (React.createElement("div", { className: "s-relative s-z-[1] s-h-0" },
            React.createElement("div", { id: "BlockActions", className: actionsVariants({ buttonDisplay, displayActions }) },
                actions && actions,
                getContentToDownload && (React.createElement(Button, { variant: "outline", size: "xs", icon: Download01, onClick: handleDownload, tooltip: "Download" })),
                content && (React.createElement(Button, { variant: "outline", size: "xs", icon: isCopied ? ClipboardCheck : Clipboard, onClick: handleCopyToClipboard, tooltip: "Copy" }))))),
        React.createElement("div", { className: cn("s-z-0 s-w-full s-min-w-0", innerClassName) }, children)));
}
//# sourceMappingURL=ContentBlockWrapper.js.map